import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-impact-approval',
    templateUrl: './impact-approval.component.html',
    styleUrl: './impact-approval.component.scss',
    standalone: false
})
export class ImpactApprovalComponent {
  // step 1: confirm screen, step 2: success screen
  step: 1 | 2 = 1;

  constructor(
    private dialogRef: MatDialogRef<ImpactApprovalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    // Here you can trigger the API to send for approval.
    // After success, move to step 2.
    this.step = 2;
  }

  onClose(result?: unknown): void {
    this.dialogRef.close(result);
  }
}
